"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAxiom = exports.withAxiomRouteHandler = exports.withAxiomNextConfig = void 0;
const config_1 = require("./config");
const logger_1 = require("./logger");
const shared_1 = require("./shared");
function withAxiomNextConfig(nextConfig) {
    return Object.assign(Object.assign({}, nextConfig), { rewrites: () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const rewrites = yield ((_a = nextConfig.rewrites) === null || _a === void 0 ? void 0 : _a.call(nextConfig));
            const webVitalsEndpoint = config_1.config.getIngestURL(shared_1.EndpointType.webVitals);
            const logsEndpoint = config_1.config.getIngestURL(shared_1.EndpointType.logs);
            if (!webVitalsEndpoint && !logsEndpoint) {
                const log = new logger_1.Logger();
                log.warn('axiom: Envvars not detected. If this is production please see https://github.com/axiomhq/next-axiom for help');
                log.warn('axiom: Sending Web Vitals to /dev/null');
                log.warn('axiom: Sending logs to console');
                return rewrites || []; // nothing to do
            }
            const axiomRewrites = [
                {
                    source: `${config_1.config.proxyPath}/web-vitals`,
                    destination: webVitalsEndpoint,
                    basePath: false,
                },
                {
                    source: `${config_1.config.proxyPath}/logs`,
                    destination: logsEndpoint,
                    basePath: false,
                },
            ];
            if (!rewrites) {
                return axiomRewrites;
            }
            else if (Array.isArray(rewrites)) {
                return rewrites.concat(axiomRewrites);
            }
            else {
                rewrites.afterFiles = (rewrites.afterFiles || []).concat(axiomRewrites);
                return rewrites;
            }
        }) });
}
exports.withAxiomNextConfig = withAxiomNextConfig;
function withAxiomRouteHandler(handler, config) {
    return (req, arg) => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        let region = '';
        if ('geo' in req) {
            region = (_b = (_a = req.geo) === null || _a === void 0 ? void 0 : _a.region) !== null && _b !== void 0 ? _b : '';
        }
        let pathname = '';
        if ('nextUrl' in req) {
            pathname = req.nextUrl.pathname;
        }
        else if (req instanceof Request) {
            // pathname = req.url.substring(req.headers.get('host')?.length || 0)
            pathname = new URL(req.url).pathname;
        }
        const requestDetails = Array.isArray(config === null || config === void 0 ? void 0 : config.logRequestDetails) || (config === null || config === void 0 ? void 0 : config.logRequestDetails) === true
            ? yield (0, shared_1.requestToJSON)(req)
            : undefined;
        const report = {
            startTime: new Date().getTime(),
            endTime: new Date().getTime(),
            path: pathname,
            method: req.method,
            host: req.headers.get('host'),
            userAgent: req.headers.get('user-agent'),
            scheme: req.url.split('://')[0],
            ip: req.headers.get('x-forwarded-for'),
            region,
            details: Array.isArray(config === null || config === void 0 ? void 0 : config.logRequestDetails)
                ? Object.fromEntries(Object.entries(requestDetails).filter(([key]) => (config === null || config === void 0 ? void 0 : config.logRequestDetails).includes(key)))
                : requestDetails,
        };
        // main logger, mainly used to log reporting on the incoming HTTP request
        const logger = new logger_1.Logger({ req: report, source: config_1.isEdgeRuntime ? 'edge' : 'lambda' });
        // child logger to be used by the users within the handler
        const log = logger.with({});
        log.config.source = config_1.isEdgeRuntime ? 'edge-log' : 'lambda-log';
        const axiomContext = req;
        const args = arg;
        axiomContext.log = log;
        try {
            const result = yield handler(axiomContext, args);
            report.endTime = new Date().getTime();
            // report log record
            report.statusCode = result.status;
            report.durationMs = report.endTime - report.startTime;
            logger.logHttpRequest(logger_1.LogLevel.info, `[${req.method}] ${report.path} ${report.statusCode} ${report.endTime - report.startTime}ms`, report, {});
            // attach the response status to all children logs
            log.attachResponseStatus(result.status);
            // flush the logger along with the child logger
            yield logger.flush();
            if (config_1.isEdgeRuntime && config_1.isVercelIntegration) {
                logEdgeReport(report);
            }
            return result;
        }
        catch (error) {
            report.endTime = new Date().getTime();
            // report log record
            report.statusCode = 500;
            report.durationMs = report.endTime - report.startTime;
            logger.logHttpRequest(logger_1.LogLevel.error, `[${req.method}] ${report.path} ${report.statusCode} ${report.endTime - report.startTime}ms`, report, {});
            log.error(error.message, { error });
            log.attachResponseStatus(500);
            yield logger.flush();
            if (config_1.isEdgeRuntime && config_1.isVercelIntegration) {
                logEdgeReport(report);
            }
            throw error;
        }
    });
}
exports.withAxiomRouteHandler = withAxiomRouteHandler;
function logEdgeReport(report) {
    console.log(`AXIOM_EDGE_REPORT::${JSON.stringify(report)}`);
}
function isNextConfig(param) {
    return typeof param == 'object';
}
function withAxiom(param, config) {
    if (typeof param == 'function') {
        return withAxiomRouteHandler(param, config);
    }
    else if (isNextConfig(param)) {
        return withAxiomNextConfig(param);
    }
    return withAxiomRouteHandler(param, config);
}
exports.withAxiom = withAxiom;
//# sourceMappingURL=withAxiom.js.map